export const BranchAddressServiceName = 'BranchAddressServiceName';
export const CroppieOptionsServiceName = 'CroppieOptionsService';
export const ImageUploadServiceName = 'ImageUploadServiceName';
export const BrandServiceName = "BrandServiceName";
export const STATISTIC_SERVICE_NAME = "STATISTIC_SERVICE_NAME";
export const DRAW_CHART_SERVICE_NAME = "DRAW_CHART_SERVICE_NAME";
export const CALCULATIONS_SERVICE_NAME = "CALCULATIONS_SERVICE_NAME";
export const CONDITION_SERVICE_NAME = "CONDITION_SERVICE";
export const CalculationNotificationServiceName = "CALCULATION_NOTIFICATION_SERVICE_NAME";
export const CUSTOMER_DETAILS_SERVICE_NAME = "CustomerDetailService";
export const ACTION_SERVICE_NAME = "ACTION_SERVICE_NAME";
export const CalculationsLogServiceName = "CalculationsLogServiceName";
export const DirectMailerLogsServiceName = "DirectMailerLogsServiceName";
export const LqbPricerLogServiceName = "LqbPricerLogServiceName";
export const ConditionParameterServiceName = 'ConditionParameterServiceName';
export const UserServiceName = "UserServiceName";
export const UserValidationServiceName = 'UserValidationServiceName';
export const BranchesServiceName = 'BranchesServiceName';
export const ToastNotificationServiceName = "ToastNotificationServiceName";
export const OpportunityNotificationToggleServiceName = "OpportunityNotificationToggleServiceName";
export const LqbPricerParameterServiceName = "LqbPricerParameterServiceName";
export const CustomerFilterParametersServiceName = "CustomerFilterParametersServiceName";
export const LqbFundedLogServiceName = 'LqbFundedLogServiceName';
export const ManualImportServiceName = 'ManualImportServiceName';
export const CustomerServiceName = "CustomerService";
export const PageTitleServiceName = 'PageTitleServiceName';
export const AddressServiceName = 'AddressServiceName';
export const SubscriptionService = 'SubscriptionService';
export const QueuedTaskServiceName = 'QUEUED_TASK_SERVICE';
export const WebSocketServiceName = 'WebSocketService';
export const CampaignServiceName = 'CampaignServiceName';
export const CampaignActionLogServiceName = 'CampaignActionLogServiceName';
export const ConversionLogControllerName = 'ConversionLogControllerName';
export const ConversionLogServiceName = 'ConversionLogServiceName';
export const UserAccessLevelPresetServiceName = 'UserAccessLevelPresetServiceName';
export const OpportunityPreRenderServiceName = 'OpportunityPreRenderServiceName';
export const LoanArchiveServiceName = 'LoanArchiveServiceName';
export const HttpResponseServiceName = 'HttpResponseServiceName';
export const LeadsControllerName = 'LeadsControllerName';
export const LeadServiceName = 'LeadServiceName';
export const PartnersControllerName = 'PartnersControllerName';
export const PartnerServiceName = 'PartnerServiceName';